import { message } from 'ant-design-vue';
import * as api from '@src/api/auth';
import type { SendMsgParams } from '@src/api/auth';

export interface SendCodeHookOptions {
    timeout: number;
}

export const useSendCode = (options?: SendCodeHookOptions) => {
    const { timeout } = options || { timeout: 60 };

    /**
     * data
     */
    const loading = ref(false);
    const second = ref(timeout);
    const text = ref('获取验证码');
    const uuid = ref('');
    let timer: ReturnType<typeof setInterval> | null = null;

    /**
     * methods
     */
    const setTimer = () => {
        text.value = `${second.value}秒后重发`;
        second.value -= 1;
        timer = setInterval(() => {
            if (second.value - 1 === 0) {
                second.value = timeout;
                text.value = '获取验证码';
                clearInterval(timer as number);
                timer = null;
                return;
            }
            second.value -= 1;
            text.value = `${second.value}秒后重发`;
        }, 1000);
    };
    const sendCode = (params: SendMsgParams) => {
        return new Promise((reslove, reject) => {
            loading.value = true;
            text.value = '发送中';
            api.sendMsg(params)
                .then(data => {
                    message.success('验证码已发送，请注意查收！');
                    uuid.value = (data as any).uuid;
                    setTimer();
                    reslove(data);
                })
                .catch(error => {
                    text.value = '获取验证码';
                    reject(error);
                })
                .finally(() => {
                    loading.value = false;
                });
        });
    };

    /**
     * computed
     */
    const disabled = computed(() => timeout !== second.value);

    return {
        sendCode,
        disabled,
        loading,
        second,
        text,
        uuid,
    };
};
